<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <p class="generic-modal-body">{{ data.body }}</p>
</div>
<div
  mat-dialog-actions
  class="generic-modal-actions"
>
  <button
    *ngIf="data.showCloseButton"
    type="button"
    class="button-close"
    aria-label="Close"
    (click)="dialogRef.close()"
  >
    &times;
  </button>
  <button
    *ngIf="!data.showOnlyAccept"
    cButton
    variant="ghost"
    color="info"
    [mat-dialog-close]="null"
  >{{ data?.cancelBtnText ?? 'Cancel' }}</button>
  <button
    *ngIf="!data.showOnlyAccept"
    cButton
    variant="ghost"
    color="danger"
    [mat-dialog-close]="true"
    cdkFocusInitial
  >
    {{ data?.okBtnText ?? 'Ok' }}
  </button>
</div>
